import { useEffect } from 'react';
import { Box3, Camera, Object3D, Scene, Vector3, type Mesh } from 'three';
import { useThree } from '@react-three/fiber';
import { useSceneSelection } from './useSceneSelection';

interface OrbitLike {
  target: Vector3;
  update?: () => void;
}

interface ThreeState {
  scene: Scene;
  camera: Camera;
  controls?: OrbitLike;
}

export function CameraFollowSelection() {
  const { scene, camera, controls } = useThree() as ThreeState;
  const selected = useSceneSelection((s) => s.selectedPartRef);

  useEffect(() => {
    if (!selected) return;
    let target: Mesh | null = null;
    scene.traverse((obj: Object3D) => {
      if (target) return;
      if ((obj as Mesh).isMesh && obj.userData?.refId === selected) target = obj as Mesh;
    });
    if (!target) return;
    const bbox = new Box3().setFromObject(target);
    const center = bbox.getCenter(new Vector3());
    const size = bbox.getSize(new Vector3()).length() || 1;
    const offset = new Vector3(size * 2.5, size * 1.5, size * 2.5);
    const camPos = center.clone().add(offset);
    (camera as { position: Vector3 }).position.lerp(camPos, 0.6);
    camera.lookAt(center);
    if (controls && 'target' in controls) {
      controls.target.copy(center);
      controls.update?.();
    }
  }, [selected, scene, camera, controls]);

  return null;
}
